import { Main } from '@/components/layout/main'
import { Separator } from '@/components/ui/separator'
import { useAuthStore } from '@/stores/auth.store'
import {
  IconTool,
  IconUsers
} from '@tabler/icons-react'
import { Outlet } from '@tanstack/react-router'
import { useMemo } from 'react'
import SidebarNav from './components/sidebar-nav'

const sidebarNavItems = [
  // {
  //   title: 'Profile',
  //   icon: <IconUser size={18} />,
  //   href: '/settings',
  // },
  {
    title: 'Conta',
    icon: <IconTool size={18} />,
    href: '/settings/account',
  },
  // {
  //   title: 'Appearance',
  //   icon: <IconPalette size={18} />,
  //   href: '/settings/appearance',
  // },
  // {
  //   title: 'Notifications',
  //   icon: <IconNotification size={18} />,
  //   href: '/settings/notifications',
  // },
  // {
  //   title: 'Display',
  //   icon: <IconBrowserCheck size={18} />,
  //   href: '/settings/display',
  // },
  {
    title: 'Config. do Time',
    icon: <IconUsers size={18} />,
    href: '/settings/team',
    ownerOnly: true,
  },
]

export default function Settings() {
  const getIsOwner = useAuthStore((state) => state.getIsOwner)
  const isOwner = getIsOwner()

  const filteredNavItems = useMemo(() => {
    return sidebarNavItems.filter((item) => {
      if (item.ownerOnly && !isOwner) {
        return false
      }
      return true
    })
  }, [isOwner])

  return (
    <Main fixed>
      <div className='space-y-0.5'>
        <h1 className='text-2xl font-bold tracking-tight md:text-3xl'>
          Configurações
        </h1>
        <p className='text-muted-foreground'>
          Gerencie suas configurações de conta e defina preferências de e-mail.
        </p>
      </div>
      <Separator className='my-4 lg:my-6' />
      <div className='flex flex-col flex-1 space-y-2 overflow-hidden md:space-y-2 lg:flex-row lg:space-x-12 lg:space-y-0'>
        <aside className='top-0 lg:sticky lg:w-1/5'>
          <SidebarNav items={filteredNavItems} />
        </aside>
        <div className='flex w-full p-1 pr-4 overflow-y-hidden'>
          <Outlet />
        </div>
      </div>
    </Main>
  )
}
